import { Field } from 'redux-form';
import TextInput from './TextInput';

const Text = (props) => {
  return ( 
    <div>
      <Field
        {...props}
        component={TextInput}
        type="text"
        placeholder=""
      />
    </div>);
}

export default Text;